import { Box, Container, Typography, Paper } from "@mui/material";
import { EventsTable } from "../common/events-table/events-table";
import IconBreadcrumbs from "../custom-breadcrumb";

const EventsPage = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#f5f8fa",
        minHeight: "100vh",
        fontFamily: "'Poppins', sans-serif",
        py: { xs: 4, md: 6 },
      }}
    >
      <IconBreadcrumbs name="Events" path="/events" />

      <Container maxWidth="lg">
        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, md: 4 },
            mt: 4,
            borderRadius: 3,
            backgroundColor: "#ffffff",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              mb: 3,
              color: "#0d1b2a",
              fontSize: { xs: "1.5rem", md: "2rem" },
            }}
          >
            Upcoming & Past Events
          </Typography>

          <EventsTable />
        </Paper>
      </Container>
    </Box>
  );
};

export default EventsPage;
